import { render, staticRenderFns } from "./TextAreaAutosize.vue?vue&type=template&id=0f429ec3"
import script from "./TextAreaAutosize.vue?vue&type=script&lang=js"
export * from "./TextAreaAutosize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports